import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { RbacService } from '../../services/rbac.service';
import { Permission } from '../../lib/rbac.config';

@Directive({ selector: '[appHasPermission]' })
export class HasPermissionDirective implements OnInit {
    @Input('appHasPermission') permission!: Permission | Permission[];

    constructor(
        private templateRef: TemplateRef<unknown>,
        private viewContainer: ViewContainerRef,
        private rbac: RbacService,
    ) {}

    ngOnInit(): void {
        const allowed = Array.isArray(this.permission)
        ? this.rbac.hasAnyPermission(this.permission)
        : this.rbac.hasPermission(this.permission);

        allowed ? this.viewContainer.createEmbeddedView(this.templateRef) : this.viewContainer.clear();
    }
}
